import { updateSession } from './updateSession.js'
import { getSessionValue } from './getSessionValue.js'
import { getUrlParams } from './getUrlParams.js'
import { getFacebookIds } from './getFacebookIds.js'

/**
 * Parses query parameters from the URL and updates session attributes accordingly.
 *
 * @param {string} sessionId - The ID of the session to update.
 * @returns {Object<string, string>}
 */

export function queryParamsToSession(sessionId) {
  /**
   * ?utm_source=affiliate
   * &utm_campaign=1151
   * &sub1=181
   * &sub2=4c8fa3617d1f4e3a9e60d0f12a738504
   * &sub3=
   * &sub4=
   * &sub5=
   * &trid=e108d3df392949929bcde66eadddbd47
   * &sourceid=
   * &oid=19
   *
   * &aff_id=
   *
   * &funnel=
   *
   * // From SessionLogic in turbodebt-site
   * &first=
   * &last=
   * &email=
   * &phone=
   * &pval=
   * &oid2=
   * &affid2=
   * &birthdate=
   * &addressLine=
   */

  const params = getUrlParams(window.location.search)

  const keysToUpdate = [
    'funnel',
    'oid',
    'sourceid',
    'sub1',
    'sub2',
    'sub3',
    'sub4',
    'sub5',
    'trid',
    'utm_source',
    'utm_campaign',
    'aff_id',
    'first',
    'last',
    'email',
    'phone',
    'pval',
    'affid2',
    'oid2',
    'utm_content',
    'utm_term',
    'campid',
    'agid',
    'rid',
    'test_pixel',
    'website',
    'debtOwed',
    'actively_paying',
    'delinquentDays',
    'paymentPlan',
    'state',
    'name',
    'xxTrustedFormCertUrl',
    'attestio_cert',
    'birthdate',
    'addressLine',
    'ip',
    'zip',
    'fbc',
    'fbp',
  ]

  /** @type {Record<string, string>} */
  const sanitizedParams = {}
  Object.keys(params).forEach((key) => {
    // camel case the incoming params to match what formSubmit processes
    sanitizedParams[key.charAt(0).toLowerCase() + key.slice(1)] = params[key]
  })

  keysToUpdate.forEach((key) => {
    const currentValue = getSessionValue(sessionId, key)
    if (sanitizedParams[key] && sanitizedParams[key] !== currentValue) {
      if (sanitizedParams[key] === '_____') {
        updateSession(sessionId, key, '')
      } else {
        updateSession(sessionId, key, sanitizedParams[key])
      }
    }
  })

  // Capture Facebook IDs from cookies/URL params for CAPI
  const { fbc, fbp } = getFacebookIds()
  if (fbc) {
    updateSession(sessionId, 'fbc', fbc)
  }
  if (fbp) {
    updateSession(sessionId, 'fbp', fbp)
  }

  return params
}
